import axios from 'axios';

const ROOT = 'api/v1/investigator-worklist';

const InvestigatorWorkListApi = {
  getInvestigatorWorklistData(data, hideLoader = true, request = null) {
    return axios.post(`${ROOT}`, data, { hideLoader: hideLoader, cancelToken: request.token });
  },
  getEncounterNamesBySsuIds(ssuIds, statuses) {
    return axios.post(
      `${ROOT}/encounter`,
      {
        ssuIds,
        statuses
      },
      { hideLoader: true }
    );
  },
  getEncounterNamesAndStudyNamesBySsuIds(ssuIds, statuses) {
    return axios.post(
      `${ROOT}/encounter-with-study`,
      {
        ssuIds,
        statuses
      },
      { hideLoader: false }
    );
  },
  getCountOfReviewsBySsuIds(ssuIds) {
    return axios.post(`${ROOT}/count`, ssuIds, { hideLoader: false });
  },
  getLogsForInvestigatorWorkListByRequest(data, hideLoader = true, request = null) {
    return axios.post(`api/v1/work-lists/logs/elements-pi`, data, {
      hideLoader: hideLoader,
      cancelToken: request.token
    });
  },
  getLogsSignedByPerGroupValuesForTable(rowIdsToTemplateIds, logCode, request) {
    return axios.post(
      `api/v1/work-lists/logs/signers-per-groups`,
      { rowIdsToTemplateIds, logCode },
      {
        hideLoader: true,
        cancelToken: request.token
      }
    );
  },
  countLogsByInvestigatorStatus(ssuIds, logCode) {
    return axios.post(`api/v1/work-lists/logs/count-pi`, { ssuIds, logCode }, { hideLoader: false });
  },
  getInvestigatorWorkListLogsSignedByFilterSignersAndSmReviewers(ssuIds, piStatuses, logCode) {
    return axios.post(
      `api/v1/work-lists/logs/filters/signers`,
      {
        ssuIds,
        piStatuses,
        smStatuses: [],
        logCode
      },
      { hideLoader: false }
    );
  },
  getInvestigatorWorkListSignedByFilterSignersAndSmReviewers(ssuIds, statuses, logCode) {
    return axios.post(
      `${ROOT}/signers`,
      {
        ssuIds,
        statuses,
        logCode
      },
      { hideLoader: true }
    );
  },
  getWorkListSignedByPerGroupValuesForTable(patientEncounterIds, request) {
    return axios.post(`${ROOT}/table/signers-per-groups`, patientEncounterIds, {
      hideLoader: true,
      cancelToken: request.token
    });
  }
};

export default InvestigatorWorkListApi;
